import { MannequinProvider } from './context/MannequinContext';
import { MannequinList } from './MannequinList';

export const Mannequin = () => {
    return (
        <MannequinProvider>
            <MannequinList />
        </MannequinProvider>
    );
};

